import React from 'react';
import { useIntl } from 'react-intl';
import TimberFrameImg from '../images/timber-frame.png';
import sipImg from '../images/sip.png';
import css from './Sections.module.css';

import Icons from '../../../components/Icons/Icons';

function SectionsTimberFrame() {
  const intl = useIntl();

  return (
    <div className={css.timberFrameSection}>
      <div className={css.timberFrame}>
        <h2>{intl.formatMessage({ id: 'SectionsTimberFrame.heading' })}</h2>
        <div className={css.volumetricModularContent}>
          <div className={css.volumetricModularImg}>
            <div className={css.ImgWrapper}>
              <img src={TimberFrameImg} alt="" />
            </div>
            <div className={css.floatingText}>
              {intl.formatMessage({ id: 'SectionsTimberFrame.description1' })}
            </div>
          </div>
          <div className={css.volumetricModularInfo}>
            <p>{intl.formatMessage({ id: 'SectionsTimberFrame.listIntro' })}</p>
            <ul>
              {[
                'list1',
                'list2',
                'list3',
                'list4',
                'list5',
                'list6',
                'list7',
              ].map((key, i) => (
                <li key={i}>
                  <Icons name="checkListIcon" />
                  {intl.formatMessage({ id: `SectionsTimberFrame.${key}` })}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className={css.timberFrame}>
        <h2>{intl.formatMessage({ id: 'SectionsSIP.heading' })}</h2>
        <div className={css.volumetricModularContent}>
          <div className={css.volumetricModularInfo}>
            <p>{intl.formatMessage({ id: 'SectionsSIP.listIntro' })}</p>
            <ul>
              {[
                'list1',
                'list2',
                'list3',
                'list4',
                'list5',
                'list6',
              ].map((key, i) => (
                <li key={i}>
                  <Icons name="checkListIcon" />
                  {intl.formatMessage({ id: `SectionsSIP.${key}` })}
                </li>
              ))}
            </ul>
          </div>
          <div className={css.volumetricModularImg}>
            <div className={css.ImgWrapper}>
              <img src={sipImg} alt="" />
            </div>
            <div className={css.floatingText}>
              {intl.formatMessage({ id: 'SectionsSIP.description' })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionsTimberFrame;
